import React from 'react'
import { isString } from 'lodash'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, makeStyles } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'

import { DraggablePaper, ContainedButton } from 'civic-champs-shared'

const useStyles = makeStyles({
  dialog: {
    background: '#F8FAFF',
    padding: '0 20px 20px',
    position: 'relative',
    maxWidth: '100%',
    width: '360px',
    height: '260px',
  },
  title: {
    cursor: 'move',
    padding: '20px 0 20px',
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '24px',
    color: '#000000',
  },
  dialogCloseButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  dialogCloseIcon: {
    fontSize: '18px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    '&:first-child': {
      padding: '10px 0 8px',
    },
    '& p': {
      margin: '0 0 0',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    padding: '8px 0 0',
  },
})

interface CustomerEditSubscriptionModalProps {
  showing: boolean
  complete: () => void
}

const CustomerEditSubscriptionModal = (props: CustomerEditSubscriptionModalProps) => {
  const { showing, complete } = props

  const classes = useStyles()

  const cancelLink = process.env.REACT_APP_CANCEL_SUBSCRIPTION_LINK
  const handleClick = () => window.open(cancelLink, '_blank')

  return (
    <Dialog
      open={showing}
      PaperComponent={DraggablePaper}
      // @ts-ignore
      PaperProps={{ handle: `#sub-info-modal` }}
      aria-labelledby="draggable-dialog-title"
      maxWidth="xs"
      classes={{ paper: classes.dialog }}
      disableEnforceFocus
    >
      <DialogTitle classes={{ root: classes.title }} disableTypography={true} id="sub-info-modal">
        Edit Subscription
        <IconButton className={classes.dialogCloseButton} onClick={() => complete()}>
          <CloseIcon className={classes.dialogCloseIcon} />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.content }}>
        <p>Need to speak to someone?</p>
        <p>
          <a href="mailto:help@civicchamps.com">help@civicchamps.com</a> can assist you with questions or concerns
          regarding your Civic Champs subscription.
        </p>
      </DialogContent>
      {isString(cancelLink) && (
        <DialogActions className={classes.actions}>
          <ContainedButton onClick={handleClick}>Cancel Subscription</ContainedButton>
        </DialogActions>
      )}
    </Dialog>
  )
}

export default CustomerEditSubscriptionModal
